import { useAuth } from 'global/cnr/contexts/useHelpers/useAuth';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { useContext, useEffect } from 'react';
import { AppUserManagerContext } from '../../cnr/contexts/AppUserManagerContext';
import { PapsContext } from '../../cnr/contexts/PapsContext';
import { appFormTypes } from '../../enums/appFormTypes';
import MotionWait from '../../motions/MotionWait';
import FullPageWrapper from '../../wrappers/FullPageWrapper';
import NoData from '../alerts/NoData';
import AppForm from '../forms/appForms/AppForm';

export const _authProjectName = null // 'pojo-1fdf3'

/** Returns a user's authentication
 * @param itemData
 */
const UserAuth = ({ selectedAppUser, inApp, handleCancel }) => {

  // papsContext
  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}

  // appUserManagerContext
  const appUserManagerContext = useContext(AppUserManagerContext)
  const { appUserManager_handlers } = appUserManagerContext ? appUserManagerContext : {}

  const { getAuth, updateAuth, ammendAuth, deleteAuth, clearConfirmation, authData, authUid, invalidUser, updating, confirmation } = useAuth()

  const { email } = authData ? authData : {}

  useEffect(() => {
    getAuth(selectedAppUser)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedAppUser]);

  // confirmation
  useEffect(() => {
    clearConfirmation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmation]);


  const handleSaveAuth = () => updateAuth(authUid, authData)
  const handleDeleteAuth = () => deleteAuth(authUid)

  const appUserForm = () => <Wrapper
    content={<AppForm
      appFormType={pathViews?.clients ? appFormTypes.appAuth : appFormTypes.auth}
      data_parent={authData}
      handleUpdateParentData={ammendAuth}
      handleSave={handleSaveAuth}
      handleDelete={handleDeleteAuth}
      updating={updating}
    />}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  const authContent = () => {
    if (invalidUser) {
      return <NoData fullCaption={'This user has not been authenticated.'} />
    } else {
      return authData ? appUserForm() : <MotionWait origin={'UserAuth'} />
    }
  }

  const fpw = () => <FullPageWrapper
    topperCaption={'Authorization'}
    topperCaption2={email}
    content={authContent()}
    handleCancel={handleCancel || appUserManager_handlers?.handleCancel} s
    css={{ container: 'app-dark-mode' }}>
  </FullPageWrapper>

  return inApp ? authContent() : fpw()

}

export default UserAuth